import type { GivingBase } from 'models';
import { DataCardBody, Icon } from 'ui';
import { useGivingCardContent } from '../hooks';

type P = {
  giving: GivingBase;
  showTag?: boolean;
  showZeroRaised?: boolean;
  titleEllipsis?: { rows: number; tooltip: boolean };
};

const GivingCardContent = ({ giving, showTag = true, showZeroRaised, titleEllipsis }: P) => {
  const { description, participantsProperties, pricesProperties, progressProperties, tagLabel } = useGivingCardContent({
    giving,
    showZeroRaised,
  });

  return (
    <DataCardBody
      description={description}
      participantsProperties={participantsProperties}
      pricesProperties={pricesProperties}
      progressProperties={progressProperties}
      tag={showTag ? { children: tagLabel, color: 'orange-dark', icon: <Icon icon="hand-heart-line" /> } : undefined}
      title={giving.name}
      titleEllipsis={titleEllipsis}
    />
  );
};

export default GivingCardContent;
